module.exports = __webpack_public_path__ + "icomoon.5674c.eot";


//////////////////
// WEBPACK FOOTER
// ./app/fonts/spinnaker/fonts/icomoon.eot
// module id = 2750
// module chunks = 0